export const buildUrlQuery = (params: { [key: string]: any }) => {
  let query = Object.keys(params)
    .filter(
      (key) =>
        params[key] !== null && params[key] !== undefined && params[key] !== ''
    )
    .map((key) => `${key}=${params[key]}`)
    .join('&')
  if (query !== '') query = '?' + query
  return query
}

export const getLocation = (url: string): HTMLAnchorElement => {
  const location = document.createElement('a')
  location.href = url
  return location
}

export const isCommentUrl = (url: string): boolean => {
  const location = getLocation(url)
  const path = location.pathname
  const hash = location.hash

  return /\/questions\/\d*/.test(path) && /#comment-\d*/.test(hash)
}

export const isQuestionUrl = (url: string): boolean => {
  const location = getLocation(url)
  const path = location.pathname
  const hash = location.hash

  return /\/questions\/\d*/.test(path) && !/#comment-\d*/.test(hash)
}

export const getQuestionId = (url: string): any => {
  if (!isQuestionUrl(url) && !isCommentUrl(url)) return null
  const matches = url.match(/\/questions\/(\d*)/)
  return matches ? parseInt(matches[1]) : null
}

export const getCommentId = (url: string): any => {
  if (!isCommentUrl(url)) return null
  const matches = url.match(/#comment-(\d*)/)
  return matches ? parseInt(matches[1]) : null
}

export interface URLUtils {
  buildUrlQuery: typeof buildUrlQuery
  getCommentId: typeof getCommentId
  getLocation: typeof getLocation
  getQuestionId: typeof getQuestionId
  isCommentUrl: typeof isCommentUrl
  isQuestionUrl: typeof isQuestionUrl
}
